// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/fonts/Mulish-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../public/fonts/Mulish-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../public/fonts/Mulish-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../public/fonts/Mulish-Black.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Mulish";
  src:
    local("Mulish Medium"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 400;
}

@font-face {
  font-family: "Mulish";
  src:
    local("Mulish Bold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 700;
}

@font-face {
  font-family: "Mulish";
  src:
    local("Mulish Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 500;
}

@font-face {
  font-family: "Mulish";
  src:
    local("Mulish Black"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: 900;
}

:root {
  --background: #f7f8fa;
  --disabled-c: #8d9bb8;
  --blue: #1860d9;
  --disabled-bg: #f7f8fa;
  --cadetGrey: #8d9bb8;
  --disabled-btn-bg: #8d9bb8;
  --white: #fff;
  --sidebar-hover: #e4ecff;
  --orange: #ffb600;
  --vivid-pink: #d91869;

  /* ------------- */
  --red: #e73027;
  --background-gray: #f5f5f5;
  --icon-gray: #f3f3f3;
  --black: #000;
  --yellow: #f4b53e;
  --dark-gray: #757575;
  --green: #238700;
  --doc-gray: #d9d9d9;
  /* --disabled-bg: #ECECEF; */
  /* --disabled-c: #C4C4C4; */
  --roman-silver: #848c9c;
  --apple: #4ca92b;
  --login-gray: #848c9c;
  --login-background: #fcfdff;
  --ghost-white: #f9f9fa;

  --sign-waiting: rgba(255, 225, 150, 1);
  --sign-signed: rgba(35, 135, 0, 0.2);
  --sign-failure: rgba(255, 172, 172, 1);
  --signed: #64b947;
  --signed-background: rgba(100, 185, 71, 0.2);
  --unsigned-background: rgba(244, 181, 62, 0.1);
  --status-cancelled: rgba(238, 109, 103, 0.2);
  --status-cancelled-color: rgba(238, 109, 103, 1);

  --signed-byYou-c: rgba(159, 223, 137, 1);
  --signed-byYou-bg: rgba(228, 236, 255, 1);
  --signed-byAll-c: rgba(76, 169, 43, 1);
  --signed-byAll-bg: rgba(213, 239, 203, 1);
  --width-sidebar: 248px;
  --width-mobile-sidebar: 291px;

  /*-----z-index-----*/

  --table: 1;
  --modal-layer: 2;
  --sidebar: 5;
  --cross: 6;
  --over-modal: 10;
}

* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
/* #root {
    height: 100dvh;
        height: -webkit-fill-available;

    display: flex;
    flex-direction: column;
} */

:focus-visible {
  outline: none;
}

html {
  height: -webkit-fill-available;
}
body {
  background-color: var(--background);
  font-family: "Mulish", sans-serif;
  font-weight: 400;
  overflow: hidden;
  font-size: 14px;
  height: 100dvh;
  -webkit-overflow-scrolling: touch;
  padding-bottom: env(safe-area-inset-bottom);
}
#root {
  height: 100%; /* ← 100% від body */
  display: flex;
  flex-direction: column;
}
main {
  display: flex;
  height: calc(100% - 66px);
}
  @media screen and (max-width: 1239px) {
main {
    padding-top: 0;
    height: calc(100% - 60px);
  }
  }

@media screen and (max-width: 767px) {
  main {
    padding-top: 0;
    height:100%;
  }
}

li {
  list-style: none;
}

a:visited {
  color: var(--black);
  text-decoration: none;
}

button {
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-style: normal;
  line-height: 1.2;
}

a {
  color: var(--black);
  text-decoration: none;
  cursor: pointer;
}

h1,
h2,
h4,
h4,
h5,
h6 {
  font-weight: normal;
}

input[type="password"]::-ms-reveal,
input[type="password"]::-ms-clear {
  display: none;
}

.popup-content {
  background-color: #ffffff;
  border: 1px solid var(--red);
  border-radius: 5px;
  padding: 10px;
  transform: translateY(8px);
  box-shadow: 0 2px 5px 0 var(--disabled-c);
}

.popup-arrow {
  display: none;
}

.MuiBackdrop-root {
  background-color: rgba(0, 0, 0, 0.5);
}

*::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}
::-webkit-scrollbar-track {
  /* box-shadow: inset 0 0 4px var(--sidebar-hover);  */
  border-radius: 10px;
}
*::-webkit-scrollbar-thumb {
  background: var(--blue);
  border-radius: 2px;
}

.MuiSlider-thumb:hover,
.Mui-active {
  box-shadow: 0 0 0 10px rgb(0 0 0 / 16%) !important;
}

.Mui-focusVisible {
  box-shadow: 0 0 0 10px rgb(0 0 0 / 6%) !important;
}

/* Change Autocomplete styles in Chrome*/
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  /* border: 1px solid var(--dark-gray);
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px; */
  /* background-color:#757575; */
  -webkit-text-fill-color: black;
  -webkit-box-shadow: none;
  transition: background-color 5000s ease-in-out 0s;
}

/* @media screen and (-webkit-min-device-pixel-ratio:0) { 
    select,
    textarea,
    input {
      font-size: 16px;
    }
  } */

.MuiSlider-thumb:hover {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.Mui-focusVisible {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}

/* .MuiSlider-thumb {
    border-radius: 2px !important;
} */

button {
  background-color: inherit;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB;;8DAEgE;EAChE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB;;8DAE8D;EAC9D,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB;;8DAEiE;EACjE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB;;8DAE+D;EAC/D,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;EAC1B,aAAa;EACb,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;;EAErB,kBAAkB;EAClB,cAAc;EACd,0BAA0B;EAC1B,oBAAoB;EACpB,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,sBAAsB;;EAEtB,sCAAsC;EACtC,oCAAoC;EACpC,sCAAsC;EACtC,iBAAiB;EACjB,4CAA4C;EAC5C,8CAA8C;EAC9C,4CAA4C;EAC5C,gDAAgD;;EAEhD,wCAAwC;EACxC,yCAAyC;EACzC,sCAAsC;EACtC,yCAAyC;EACzC,sBAAsB;EACtB,6BAA6B;;EAE7B,oBAAoB;;EAEpB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,SAAS;AACX;AACA;;;;;;GAMG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iCAAiC;EACjC,2CAA2C;AAC7C;AACA;EACE,YAAY,EAAE,oBAAoB;EAClC,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B;EACE;AACF;IACI,cAAc;IACd,yBAAyB;EAC3B;EACA;;AAEF;EACE;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;;;;EAME,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,qDAAqD;EACrD,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;AAEA,wCAAwC;AACxC;;;;;;;;;EASE;;sCAEoC;EACpC,8BAA8B;EAC9B,8BAA8B;EAC9B,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;;;;;;KAMK;;AAEL;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX","sourcesContent":["@font-face {\n  font-family: \"Mulish\";\n  src:\n    local(\"Mulish Medium\"),\n    url(\"../../public/fonts/Mulish-Medium.ttf\") format(\"truetype\");\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Mulish\";\n  src:\n    local(\"Mulish Bold\"),\n    url(\"../../public/fonts/Mulish-Bold.ttf\") format(\"truetype\");\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: \"Mulish\";\n  src:\n    local(\"Mulish Regular\"),\n    url(\"../../public/fonts/Mulish-Regular.ttf\") format(\"truetype\");\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: \"Mulish\";\n  src:\n    local(\"Mulish Black\"),\n    url(\"../../public/fonts/Mulish-Black.ttf\") format(\"truetype\");\n  font-weight: 900;\n}\n\n:root {\n  --background: #f7f8fa;\n  --disabled-c: #8d9bb8;\n  --blue: #1860d9;\n  --disabled-bg: #f7f8fa;\n  --cadetGrey: #8d9bb8;\n  --disabled-btn-bg: #8d9bb8;\n  --white: #fff;\n  --sidebar-hover: #e4ecff;\n  --orange: #ffb600;\n  --vivid-pink: #d91869;\n\n  /* ------------- */\n  --red: #e73027;\n  --background-gray: #f5f5f5;\n  --icon-gray: #f3f3f3;\n  --black: #000;\n  --yellow: #f4b53e;\n  --dark-gray: #757575;\n  --green: #238700;\n  --doc-gray: #d9d9d9;\n  /* --disabled-bg: #ECECEF; */\n  /* --disabled-c: #C4C4C4; */\n  --roman-silver: #848c9c;\n  --apple: #4ca92b;\n  --login-gray: #848c9c;\n  --login-background: #fcfdff;\n  --ghost-white: #f9f9fa;\n\n  --sign-waiting: rgba(255, 225, 150, 1);\n  --sign-signed: rgba(35, 135, 0, 0.2);\n  --sign-failure: rgba(255, 172, 172, 1);\n  --signed: #64b947;\n  --signed-background: rgba(100, 185, 71, 0.2);\n  --unsigned-background: rgba(244, 181, 62, 0.1);\n  --status-cancelled: rgba(238, 109, 103, 0.2);\n  --status-cancelled-color: rgba(238, 109, 103, 1);\n\n  --signed-byYou-c: rgba(159, 223, 137, 1);\n  --signed-byYou-bg: rgba(228, 236, 255, 1);\n  --signed-byAll-c: rgba(76, 169, 43, 1);\n  --signed-byAll-bg: rgba(213, 239, 203, 1);\n  --width-sidebar: 248px;\n  --width-mobile-sidebar: 291px;\n\n  /*-----z-index-----*/\n\n  --table: 1;\n  --modal-layer: 2;\n  --sidebar: 5;\n  --cross: 6;\n  --over-modal: 10;\n}\n\n* {\n  box-sizing: border-box;\n  padding: 0;\n  margin: 0;\n}\n/* #root {\n    height: 100dvh;\n        height: -webkit-fill-available;\n\n    display: flex;\n    flex-direction: column;\n} */\n\n:focus-visible {\n  outline: none;\n}\n\nhtml {\n  height: -webkit-fill-available;\n}\nbody {\n  background-color: var(--background);\n  font-family: \"Mulish\", sans-serif;\n  font-weight: 400;\n  overflow: hidden;\n  font-size: 14px;\n  height: 100dvh;\n  -webkit-overflow-scrolling: touch;\n  padding-bottom: env(safe-area-inset-bottom);\n}\n#root {\n  height: 100%; /* ← 100% від body */\n  display: flex;\n  flex-direction: column;\n}\nmain {\n  display: flex;\n  height: calc(100% - 66px);\n}\n  @media screen and (max-width: 1239px) {\nmain {\n    padding-top: 0;\n    height: calc(100% - 60px);\n  }\n  }\n\n@media screen and (max-width: 767px) {\n  main {\n    padding-top: 0;\n    height:100%;\n  }\n}\n\nli {\n  list-style: none;\n}\n\na:visited {\n  color: var(--black);\n  text-decoration: none;\n}\n\nbutton {\n  border-radius: 10px;\n  border: none;\n  cursor: pointer;\n  font-family: inherit;\n  font-style: normal;\n  line-height: 1.2;\n}\n\na {\n  color: var(--black);\n  text-decoration: none;\n  cursor: pointer;\n}\n\nh1,\nh2,\nh4,\nh4,\nh5,\nh6 {\n  font-weight: normal;\n}\n\ninput[type=\"password\"]::-ms-reveal,\ninput[type=\"password\"]::-ms-clear {\n  display: none;\n}\n\n.popup-content {\n  background-color: #ffffff;\n  border: 1px solid var(--red);\n  border-radius: 5px;\n  padding: 10px;\n  transform: translateY(8px);\n  box-shadow: 0 2px 5px 0 var(--disabled-c);\n}\n\n.popup-arrow {\n  display: none;\n}\n\n.MuiBackdrop-root {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n*::-webkit-scrollbar {\n  width: 2px;\n  height: 2px;\n}\n::-webkit-scrollbar-track {\n  /* box-shadow: inset 0 0 4px var(--sidebar-hover);  */\n  border-radius: 10px;\n}\n*::-webkit-scrollbar-thumb {\n  background: var(--blue);\n  border-radius: 2px;\n}\n\n.MuiSlider-thumb:hover,\n.Mui-active {\n  box-shadow: 0 0 0 10px rgb(0 0 0 / 16%) !important;\n}\n\n.Mui-focusVisible {\n  box-shadow: 0 0 0 10px rgb(0 0 0 / 6%) !important;\n}\n\n/* Change Autocomplete styles in Chrome*/\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  /* border: 1px solid var(--dark-gray);\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px; */\n  /* background-color:#757575; */\n  -webkit-text-fill-color: black;\n  -webkit-box-shadow: none;\n  transition: background-color 5000s ease-in-out 0s;\n}\n\n/* @media screen and (-webkit-min-device-pixel-ratio:0) { \n    select,\n    textarea,\n    input {\n      font-size: 16px;\n    }\n  } */\n\n.MuiSlider-thumb:hover {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.Mui-focusVisible {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n/* .MuiSlider-thumb {\n    border-radius: 2px !important;\n} */\n\nbutton {\n  background-color: inherit;\n}\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
